import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FilesCommentsFormComponent } from './files-comments-form/files-comments-form.component';
import { WidgetsModule } from 'app/shared/components/widgets/widgets.module';
import { MatIconModule } from '@angular/material/icon';
import { MatLegacyButtonModule as MatButtonModule } from '@angular/material/legacy-button';
import { MatLegacyTooltipModule as MatTooltipModule } from '@angular/material/legacy-tooltip';

@NgModule({
  declarations: [FilesCommentsFormComponent],
  imports: [CommonModule, MatIconModule, MatButtonModule, MatTooltipModule, WidgetsModule],
})
export class FilesCommentsFormModule {}
